import React from "react";
import * as Styles from "../../../../../common-deprecated/styles/v2/lexus/custom/SelectPane";
import Icon from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { useCompareV2Selector } from "../../../redux/store";
import type { GradesAndBodyTypeType } from "../../../utils/compareTypes";
import { CompareV2Label } from "../../../utils/labels";
import { isRTL } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ModelGradeBodyTypeIdsType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";

type GradePanelPropsType = {
    setSelectedCar: (car: ModelGradeBodyTypeIdsType) => void;
    selectedCar: ModelGradeBodyTypeIdsType;
    clearSelection: () => void;
};

const GradePanel = (props: GradePanelPropsType): JSX.Element => {
    const { selectedCar, setSelectedCar, clearSelection } = props;
    const availableCarsData = useCompareV2Selector((state) => state.newCarCompare.available);
    const settings = useCompareV2Selector((state) => state.commonSettings);
    const selectedGrades = useCompareV2Selector(({ newCarCompare }) =>
        newCarCompare.grades.map(({ gradeId, bodyTypeId, submodelId }) => submodelId + gradeId + bodyTypeId),
    );

    const subModel = availableCarsData
        ?.find((m) => m.modelId === selectedCar.model)
        ?.subModels?.find((sm) => sm.subModelId === selectedCar.submodelId);

    // Grades and bodytype don't need to be seperate. they can be flattened for this panel.
    const availableGrades = subModel?.grades
        .reduce((subModelAccumulator: GradesAndBodyTypeType[], grade) => {
            return grade.bodyTypes.reduce((gradeAccumulator: GradesAndBodyTypeType[], bodyType) => {
                return gradeAccumulator.concat({
                    subModelId: subModel.subModelId,
                    subModelName: subModel.subModelName,
                    gradeId: grade.gradeId,
                    bodyTypeId: bodyType.bodyTypeId,
                    bodyTypeName: bodyType.bodyTypeName,
                    gradeName: grade.gradeName,
                });
            }, subModelAccumulator);
        }, [])
        .filter(({ gradeId, bodyTypeId, subModelId }) => !selectedGrades.includes(subModelId + gradeId + bodyTypeId));

    return (
        <Styles.Panel>
            {selectedCar.model && (
                <Styles.Header onClick={clearSelection}>
                    <Styles.HeaderButton>
                        <IconWrapper>
                            <Icon variant={isRTL(settings) ? "arrowRight" : "arrowLeft"} />
                        </IconWrapper>
                    </Styles.HeaderButton>
                    <CompareV2Label label="compareSelectBack" />
                </Styles.Header>
            )}
            <Styles.PanelContent>
                <Styles.PanelScroll>
                    {availableGrades &&
                        availableGrades.map(({ gradeId, gradeName, bodyTypeId, bodyTypeName }) => (
                            <Styles.PanelItem
                                key={gradeId + gradeName + bodyTypeName}
                                selected={selectedCar.gradeId === gradeId}
                                onClick={() =>
                                    setSelectedCar({
                                        ...selectedCar,
                                        gradeId,
                                        bodyTypeId,
                                    })
                                }
                            >
                                {gradeName.trim()}
                            </Styles.PanelItem>
                        ))}
                </Styles.PanelScroll>
            </Styles.PanelContent>
        </Styles.Panel>
    );
};

export default GradePanel;
